var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    class: _vm.rowClass
  }, [_vm._l(_vm.limit, function (depth, index) {
    return [_c('v-col', {
      key: index,
      class: _vm.colClass,
      attrs: {
        "cols": _vm.cols || 12,
        "sm": _vm.sm || 12 / _vm.limit,
        "md": _vm.md || 12 / _vm.limit
      }
    }, [_c('v-select', _vm._b({
      on: {
        "input": _vm.emit
      }
    }, 'v-select', Object.assign({}, _vm.$attrs, {
      label: "".concat(depth, "\uCC28 \uCE74\uD14C\uACE0\uB9AC"),
      value: _vm.select(depth),
      items: _vm.items(depth),
      itemText: 'name',
      itemValue: '_id',
      itemDisabled: _vm.itemDisabled,
      placeholder: _vm.placeholder
    }), false))], 1)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }